<div class="modal modal-big">
    <h4>Edit Filter Expression</h4>
    <div class="divider"></div>

    <!-- Tab dimfilter -->
    <ng-container *ngIf="selectedTabId && tabDimensionsFilter && selectingDimValueForTabDimIndex === undefined">
        <div class="mt-24">
            <div class="body-1 mb-8">
                <b>Driver dimensions</b>
            </div>
            <div class="data-legend">
                <ul class="ellipses ellipses-root ellipses-inline">
                    <li *ngFor="let hier of tabDimensionsFilter">
                        <div [ngClass]="{ 'ellipses-group': hier.length > 1 }">
                            <div *ngFor="let dim of hier.slice().reverse()" class="ellipses-group_ellipse">
                                <div (click)="enableDimensionValueSelectionForTabDimFilter(dim)" [attr.content]="dim.isAll ? 'All' : dim.value" class="ellipse" [style.--background-color]="dim.bgColor"
                                    [style.--color]="dim.fontColor" style="cursor: pointer;">
                                    <b class="ellipse-text">{{ dim.isAll ? 'All' : dim.value }}</b>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>

    <!-- Main dimfilter -->
    <ng-container *ngIf="!selectedTabId && dimensionsFilter && selectingDimensionForItemIndexed === undefined && selectingValueForItemIndexed === undefined">
        <div *ngIf="!dimensionsFilter.items || !dimensionsFilter.items.length" class="mt-24">
            <button (click)="addNewDimensionFilterItem(0)" class="btn btn-primary">
                <span class="material-icons-outlined">add</span>
                Add New
            </button>
        </div>
        <div *ngIf="dimensionsFilter.items && dimensionsFilter.items.length" class="block-sql mt-24">
            <ng-container *ngFor="let item of dimensionsFilter.items; let i = index">
                <div class="wrap">
                    <div class="ellipses ellipses-root">
                        <div (click)="toggleAnd(item)" [ngClass]="{
                                'ellipse': true,
                                'large': true,
                                'ellipse-button': true,
                                'selected': item.operationType == LogicalOperationType.And
                            }" content="And">
                            <b class="ellipse-text">And</b>
                        </div>
                        <div (click)="toggleOr(item)" [ngClass]="{
                                'ellipse': true,
                                'large': true,
                                'ellipse-button': true,
                                'selected': item.operationType == LogicalOperationType.Or
                            }" content="Or">
                            <b class="ellipse-text">Or</b>
                        </div>
                    </div>
                    <div class="ellipses ellipses-root">
                        <span *ngIf="item.openBracketsCount > 0" class="paren" [ngClass]="{
                                'text-300': item.openBracketsCount > 3,
                                'text-500': item.openBracketsCount > 5
                            }">
                            <ng-container *ngFor="let j of [].constructor(item.openBracketsCount)">&#40;</ng-container>
                        </span>
                        <div (click)="addOpenBracket(item)" class="ellipse large ellipse-button">
                            <b class="ellipse-text">+</b>
                        </div>
                        <div (click)="removeOpenBracket(item)" class="ellipse large ellipse-button">
                            <b class="ellipse-text">-</b>
                        </div>
                        <div (click)="toggleNot(item)" [ngClass]="{
                                'ellipse': true,
                                'large': true,
                                'ellipse-button': true,
                                'selected': item.not
                            }" content="Not">
                            <b class="ellipse-text">Not</b>
                        </div>
                        <div (click)="editItemVal(i)" class="ellipse ellipse-button ellipse-long large" [ngClass]="{ 'white': !item.value }" [attr.content]="item.value ? item.value : 'Variable'"
                            [style.background-color]="item.bgColor">
                            <b class="ellipse-text">{{ item.value ? item.value : 'Variable' }}</b>
                        </div>
                        <div (click)="removeCloseBracket(item)" class="ellipse large ellipse-button">
                            <b class="ellipse-text">-</b>
                        </div>
                        <div (click)="addCloseBracket(item)" class="ellipse large ellipse-button">
                            <b class="ellipse-text">+</b>
                        </div>
                        <span *ngIf="item.closeBracketsCount > 0" class="paren" [ngClass]="{
                                'text-300': item.closeBracketsCount > 3,
                                'text-500': item.closeBracketsCount > 5
                            }">
                            <ng-container *ngFor="let j of [].constructor(item.closeBracketsCount)">&#41;</ng-container>
                        </span>
                    </div>
                    <div class="hover-actions">
                        <button (click)="addNewDimensionFilterItem(i)" class="btn btn-text btn-small"><span class="material-icons-outlined">add</span>Above</button>
                        <button (click)="addNewDimensionFilterItem(i + 1)" class="btn btn-text btn-small"><span class="material-icons-outlined">add</span>Below</button>
                        <button (click)="removeDimensionsFilterItem(i)" class="btn btn-text btn-small"><span class="material-icons-outlined">delete</span>Remove</button>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="selectingDimensionForItemIndexed != undefined">
        <div>
            <div class="mb-24">
                <div class="body-1">
                    Select dimension
                    <a (click)="cancelDimensionSelection()" class="action" style="cursor: pointer; margin-left: 16px;">cancel</a>
                </div>
                <div class="data-legend">
                    <ul *ngIf="legend && legend.length" class="ellipses ellipses-root ellipses-inline mt-8">
                        <li>
                            <div *ngFor="let hier of legend" [ngClass]="{ 'ellipses-group': hier.length > 1 }">
                                <div *ngFor="let legItem of hier.slice().reverse()" class="ellipses-group_ellipse">
                                    <div (click)="selectDimension(legItem)" class="ellipse" [style.--background-color]="legItem.bgColor" [style.--color]="legItem.fontColor"
                                        [attr.content]="legItem.name" style="cursor: pointer;">
                                        <b class="ellipse-text">{{ legItem.name }}</b>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="selectingValueForItemIndexed != undefined || selectingDimValueForTabDimIndex != undefined">
        <div>
            <div class="mb-24">
                <div class="d-flex align-items-center">
                    <span class="body-1">Select dimension value</span>
                    <div class="actions">
                        <a (click)="setTabDimValToIsAll()" *ngIf="selectingDimValueForTabDimIndex != undefined" class="action">remove</a>
                        <a (click)="selectingDimValueForTabDimIndex != undefined ? cancelDimensionValueSelectionForTab() : cancelDimensionValueSelection()" class="action">cancel</a>
                    </div>
                </div>
                <div class="data-legend">
                    <ul class="ellipses ellipses-root ellipses-inline mt-8">
                        <li *ngIf="selectedDimensionName">
                            <div class="ellipse" [style.--background-color]="selectedDimensionName.bgColor" [style.--color]="selectedDimensionName.fontColor"
                                [attr.content]="selectedDimensionName.name">
                                <b class="ellipse-text">{{ selectedDimensionName.name }}</b>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="body-1 mb-8">
                    Select value
                </div>
                <div class="search expanded">
                    <div class="input-search">
                        <label for="searchDimensionValue" class="material-icons">search</label>
                        <input [(ngModel)]="dimensionValuesFilter" (input)="applyDimensionValuesFilter()" type="text" id="searchDimensionValue" placeholder="Type to search..." />
                    </div>
                    <div class="search-results">
                        <ul *ngIf="filteredDimensionValues?.length">
                            <li *ngFor="let str of filteredDimensionValues">
                                <a class="subtitle-2" (click)="selectingDimValueForTabDimIndex != undefined ? selectDimensionValueForTab(str) : selectDimensionValue(str)">
                                    {{ str }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!selectedTabId && dimensionsFilter && dimensionsFilter.items && dimensionsFilter.items.length > 0">
        <div>
            <div class="body-1">
                Filter expression
            </div>
            <div class="formula body-2">
                {{ getFilterExpression() }}
            </div>
        </div>
    </ng-container>
    <div class="divider"></div>
    <div *ngIf="errorMessage" class="error-message" style="color: #d32f2f; margin-bottom: 16px; padding: 12px; background-color: #ffebee; border-radius: 4px;">
        <strong>Error:</strong> {{ errorMessage }}
    </div>
    <div class="mt-16">
        <button (click)="save()" [ngClass]="{'loading-small':loading}" class="btn btn-primary mr-16">
            <span *ngIf="!loading">Done</span>
            <span *ngIf="loading">Applying...</span>
        </button>
        <button (click)="cancel()" [disabled]="loading" class="btn btn-secondary">Cancel</button>
    </div>
    <a (click)="cancel()" class="btn-close material-icons-outlined" [style.cursor]="loading ? 'not-allowed' : 'pointer'" [style.opacity]="loading ? '0.5' : '1'"
        [style.pointer-events]="loading ? 'none' : 'auto'">close</a>
</div>
